module.exports = __webpack_public_path__ + "static/img/Inspiron_15_5557.d4d583df.png";